import { IDeserialize } from "src/app/models/abstraction/IDeserialize";

import { TechCoverTicketStatus } from "./Enums";

export class TechCoverTicket implements IDeserialize<TechCoverTicket> {
  salesforceId: string;
  caseNumber: string;
  subject?: string;
  description?: string;
  productName?: string;
  status: TechCoverTicketStatus;
  createdDate: Date;
  createdBy: string;
  closedDate?: Date;

  deserialize(dto: TechCoverTicket): TechCoverTicket {
    if (!dto) return this;

    Object.assign(this, dto);
    this.createdDate = new Date(dto.createdDate);
    this.closedDate = dto.closedDate ? new Date(dto.closedDate) : null;

    return this;
  }
}
